import script from "./TraceBarCode.vue?vue&type=script&setup=true&lang=js"
export * from "./TraceBarCode.vue?vue&type=script&setup=true&lang=js"

import "./TraceBarCode.vue?vue&type=style&index=0&id=bd1d68ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd1d68ea"]])

export default __exports__